// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserCard_section__HUbD2,
.UserCard_sectionGreen__VifwG,
.UserCard_sectionOdd__iK095 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 5px;
  color: #838383;
}
.UserCard_section__HUbD2 strong,
.UserCard_sectionGreen__VifwG strong,
.UserCard_sectionOdd__iK095 strong {
  color: var(--primary-color);
}
@media (min-width: 320px) {
  .UserCard_section__HUbD2,
  .UserCard_sectionGreen__VifwG,
  .UserCard_sectionOdd__iK095 {
    flex-direction: column;
  }
}
@media (min-width: 1360px) {
  .UserCard_section__HUbD2,
  .UserCard_sectionGreen__VifwG,
  .UserCard_sectionOdd__iK095 {
    flex-direction: column;
  }
}

@media (min-width: 320px) {
  .UserCard_sectionOdd__iK095 {
    flex-direction: column;
  }
}
@media (min-width: 1023px) {
  .UserCard_sectionOdd__iK095 {
    flex-direction: row;
  }
}
@media (min-width: 1360px) {
  .UserCard_sectionOdd__iK095 {
    flex-direction: row;
  }
}

.UserCard_subSection__ijrab {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
@media (min-width: 320px) {
  .UserCard_subSection__ijrab {
    flex-direction: column;
    margin-bottom: 10px;
  }
}
@media (min-width: 1360px) {
  .UserCard_subSection__ijrab {
    flex-direction: row;
  }
}

.UserCard_row__KUPWP {
  flex-direction: row;
}

.UserCard_sectionGreen__VifwG {
  color: var(--accent-color);
}

.UserCard_btnContainer__95Vke {
  display: block;
  flex-direction: row;
  align-self: center;
}
@media (min-width: 320px) {
  .UserCard_btnContainer__95Vke {
    text-align: center;
  }
}
@media (min-width: 320px) {
  .UserCard_btnContainer__95Vke button {
    display: inline-flex;
  }
}

.UserCard_inactive__8HYm0 {
  opacity: 0.5;
}

.UserCard_buttons__zrMzx {
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  justify-content: center;
}
.UserCard_buttons__zrMzx button {
  min-width: 100px;
}
@media (min-width: 320px) {
  .UserCard_buttons__zrMzx {
    margin-top: 20px;
  }
}
@media (min-width: 720px) {
  .UserCard_buttons__zrMzx {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/UserCard/UserCard.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_media.scss"],"names":[],"mappings":"AAIA;;;EAGE,aAAA;EACA,sBAAA;EACA,QCLU;EDMV,kBCDS;EDET,cEFS;AFDX;AAKE;;;EACE,2BEdM;AFaV;AGFI;EHPJ;;;IAcI,sBAAA;EACF;AACF;AGOI;EHvBJ;;;IAkBI,sBAAA;EAIF;AACF;;AGhBI;EHeJ;IAEI,sBAAA;EAIF;AACF;AGVI;EHGJ;IAMI,mBAAA;EAKF;AACF;AGXI;EHDJ;IAUI,mBAAA;EAMF;AACF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,SCrCU;AD2CZ;AGtCI;EH6BJ;IAMI,sBAAA;IACA,mBAAA;EAOF;AACF;AG5BI;EHaJ;IAWI,mBAAA;EAQF;AACF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,0BE1DO;AFkET;;AALA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAQF;AG/DI;EHoDJ;IAKI,kBAAA;EAUF;AACF;AGpEI;EH4DF;IAEI,oBAAA;EAUJ;AACF;;AANA;EACE,YAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;AASF;AAPE;EACE,gBAAA;AASJ;AGvFI;EHuEJ;IAWI,gBAAA;EASF;AACF;AGpFI;EH+DJ;IAeI,sBAAA;EAUF;AACF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.section,\n.sectionGreen,\n.sectionOdd {\n  display: flex;\n  flex-direction: column;\n  gap: $padding-s;\n  margin-bottom: $margin-s;\n  color: $grey-400;\n\n  strong {\n    color: $primary;\n  }\n\n  @include media(xss) {\n    flex-direction: column;\n  }\n\n  @include media(lg) {\n    flex-direction: column;\n  }\n}\n\n.sectionOdd {\n  @include media(xss) {\n    flex-direction: column;\n  }\n\n  @include media(md) {\n    flex-direction: row;\n  }\n\n  @include media(lg) {\n    flex-direction: row;\n  }\n}\n\n.subSection {\n  display: flex;\n  flex-direction: row;\n  gap: $padding-l;\n\n  @include media(xss) {\n    flex-direction: column;\n    margin-bottom: 10px;\n  }\n\n  @include media(lg) {\n    flex-direction: row;\n  }\n}\n\n.row {\n  flex-direction: row;\n}\n\n.sectionGreen {\n  color: $accent;\n}\n\n.btnContainer {\n  display: block;\n  flex-direction: row;\n  align-self: center;\n  @include media(xss) {\n    text-align: center;\n  }\n\n  button {\n    @include media(xss) {\n      display: inline-flex;\n    }\n  }\n}\n\n.inactive {\n  opacity: 0.5;\n}\n\n.buttons {\n  display: flex;\n  flex-direction: row;\n  align-self: flex-end;\n  justify-content: center;\n\n  button {\n    min-width: 100px;\n  }\n\n  @include media(xss) {\n    margin-top: 20px;\n  }\n\n  @include media(sm) {\n    flex-direction: column;\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `UserCard_section__HUbD2`,
	"sectionGreen": `UserCard_sectionGreen__VifwG`,
	"sectionOdd": `UserCard_sectionOdd__iK095`,
	"subSection": `UserCard_subSection__ijrab`,
	"row": `UserCard_row__KUPWP`,
	"btnContainer": `UserCard_btnContainer__95Vke`,
	"inactive": `UserCard_inactive__8HYm0`,
	"buttons": `UserCard_buttons__zrMzx`
};
export default ___CSS_LOADER_EXPORT___;
